import { AppState } from "@Store/index";
import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { shouldFetchProperty, fetchPropertyPageDataIfNeeded } from "./data/propertyPageReducer";
import { updateInventoryId } from "@App/appReducer";

const usePropertyPage = (props: any) => {
  const { location } = props;

  const dispatch = useDispatch();
  const { isError, isLoading, isStatus500, showFullPageLoader, error, id, isInternal } =
    useSelector(
      ({ propertyPageData, appData }: AppState) => ({
        isError: propertyPageData.readyStatus === "failure",
        isStatus500: !JSON.stringify(propertyPageData.error)?.includes("404"),
        error: JSON.stringify(propertyPageData.error),
        isLoading:
          propertyPageData.readyStatus === "request" ||
          shouldFetchProperty(propertyPageData, props?.match?.params?.id, "", true) ||
          appData?.isLoadingTranslations,
        showFullPageLoader:
          !propertyPageData.data ||
          propertyPageData?.data?.canonical_name !== props?.match?.params?.id ||
          appData?.isLoadingTranslations,
        id: propertyPageData?.data?.id,
        isInternal: appData?.isInternalUser,
      }),
      shallowEqual,
    );
  console.log(error);

  useEffect(() => {
    if (isError && isStatus500) {
      if (typeof window !== undefined) {
        window?.Sentry?.captureException(error);
      }
    }
  }, [isError, isStatus500]);

  useEffect(() => {
    // @ts-ignore
    if (typeof fbq !== "undefined" && fbq !== null) {
      const contentIds = id ? [id?.toString()] : undefined;

      // @ts-ignore
      fbq(
        "track",
        "ViewContent",
        contentIds ? { content_ids: contentIds, content_type: "product" } : {},
      );
    }
    dispatch(updateInventoryId({ inventoryId: `${id}` }));
  }, [id]);

  useEffect(() => {
    dispatch(fetchPropertyPageDataIfNeeded(props));
  }, [dispatch, location.pathname]);

  return {
    isLoading,
    isError,
    isStatus500,
    showFullPageLoader,
    isInternal,
  };
};

export default usePropertyPage;
